import React from "react";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import LessonsReservationPage from "../LessonsReservationPage/LessonsReservationPage";
import "./NewLessonsReservationPage.css";

const NewLessonsReservationPage: React.FC = () => {
  return (
    <>
      <LumenNavbar />
      <div className="new-lessons-reservation-wrapper">
        <LessonsReservationPage />
      </div>
      <NewFooter />
    </>
  );
};

export default NewLessonsReservationPage;
